<style lang="scss">
.Products {
    width: 90%;
    margin: 0 auto;

       .table {
        width: 100%;

        .sorting {
            background-image: url('/images/sort_both.png');
            background-repeat: no-repeat;
            background-position: center right;
        }
        .sorting_asc {
            background-image: url('/images/sort_asc.png');
            background-repeat: no-repeat;
            background-position: center right;
        }
        .sorting_desc {
            background-image: url('/images/sort_desc.png');
            background-repeat: no-repeat;
            background-position: center right;
        }
    }

}


h1 {
    text-align: center;
    font-size: 30px;
}
</style>

<template>
<div>
    <div class="Products" v-if="$gate.isAdmin() || $gate.isReception() || $gate.isManager() || $gate.isSupervisor()">

            <div class="row">
                <div class="col-sm-12 mb-2">
                    <div class="text-right">

                        <button type="button" class="btn btn-success btn-md" data-toggle="modal" data-target="#vmbc"><i class="fa fa-plus"></i></button>
                        <add />
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-11">
                    <input type="text" class="form-control" v-model="tableData.search" placeholder="Search" @input="getProducts()">
                </div>
                <div class="col-sm-1">
                    <select class="form-control" v-model="tableData.length" @change="getProducts()">
                        <option v-for="(records, index) in perPage"
                        :key="index"
                        :value="records">{{records}}</option>
                    </select>
                </div>

                <div class="col-sm-12 mt-2">
                    <datatable :columns="columns"
                        :sortKey="sortKey"
                        :sortOrders="sortOrders"
                        @sort="sortBy">

                        <tbody>
                            <tr v-for="product in products" :key="product.id">
                                <td>{{product.name}}</td>
                                <!-- <td>{{product.category}}</td> -->
                                <td>{{product.xero}}</td>
                                <td>
                                    <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" :data-target="'#vmbc'+ product.id"><i class="fa fa-edit white"></i></button>
                                    <!-- Modal -->
                                    <edit :product="product" />

                                    <button type="button" class="btn btn-success btn-sm" @click="ViewOption(product.id)" data-toggle="modal" :data-target="'#vmbc-cart'+ product.id"><i class="fa fa-shopping-cart white"></i></button>
                                    <options :products="productOption" :id="product.id" :productname="product.name" />

                                    <button type="button" class="btn btn-danger btn-sm" @click="deleteProduct(product.id)"><i class="fa fa-trash white"></i></button>
                                    <del />
                                </td>
                            </tr>
                        </tbody>
                    </datatable>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-4">
                    <excel
                        class = "btn btn-info"
                        :fetch   = "fetchExport"
                        :fields = "exportFields"
                        type    = "csv"
                        name = "Other Services.xls">
                        Download Excel
                    </excel>
                </div>
                <div class="col-sm-5">

                </div>
                <div class="col-sm-3">
                    <pagination :pagination="pagination"
                        @prev="getProducts(pagination.prevPageUrl)"
                        @next="getProducts(pagination.nextPageUrl)">
                </pagination>
                </div>
            </div>

    </div>
    <div class="row" v-else>
            <notfound></notfound>
    </div>
</div>
</template>

<script>
// import { ModelSelect } from 'vue-search-select'

import Datatable from './../datatable/Datatable.vue';
import Pagination from './../datatable/Pagination.vue';
import Options from './Product/OtherProductOption.vue';
import EditProduct from './Product/OtherProductEdit.vue';
import AddProduct from './Product/OtherProductAdd.vue';
import JsonExcel from 'vue-json-excel';
import { ModelSelect } from 'vue-search-select'

export default {
    components: {
        ModelSelect,
        datatable: Datatable,
        pagination: Pagination,
        excel: JsonExcel,
        options: Options,
        edit: EditProduct,
        add: AddProduct,
        },
    data() {
        let sortOrders = {};
        let columns = [
            {width: '50%', label: 'Product', name: 'name'},
            {width: '10%', label: 'Xero', name: 'xero'},
            {width: '20%', label: 'Action', name: 'action'},
        ];

        columns.forEach((column) => {
            sortOrders[column.name] = -1;
        });

        return {
            products: [],
            // categories:[],
            columns: columns,
            sortKey: 'deadline',
            sortOrders: sortOrders,
            perPage: ['5', '10', '20', '30'],
            tableData: {
                draw: 0,
                length: 10,
                search: '',
                column: 0,
                dir: 'desc',
                user_id: this.$root.id,
                name: this.$root.staffname,
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
            },
            exportFields: {
                'product Name': 'product',
                'Option': 'option',
                'Quantity': 'quantity',
                'Price': 'price',
                'Xero': 'xero',
            },

            productOption: [],
        }
    },
    created(){
        this.getProducts();
    },
    methods: {
        getProducts(url = '/api/others'){
            this.tableData.draw++;
            axios
            .get(url, {params: this.tableData})
            .then(response => {
                let data = response.data;
                if(this.tableData.draw = data.draw) {
                    this.products = data.data.data;
                    // this.categories = data.category;
                    this.configPagination(data.data);
                    console.log(response.data)
                }
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        configPagination(data) {
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },
        sortBy(key) {
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = this.sortOrders[key] === 1? 'asc' : 'desc';
            this.getProducts();
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },

        async fetchExport () {
            const response = await axios.get('/api/exportotherproduct');
            console.log(response);
            return response.data;
        },
        ViewOption(id){
            axios
            .get('./api/Others/'+id+'/Option')
            .then((result) => {
                this.productOption = result.data
            }).catch((err) => {

            });
        },
        deleteProduct(product) {
            Swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                if (result.value) {
                    Swal(
                        'Deleted!',
                        'Your file has been deleted.',
                        'success',
                        axios
                        .get('./api/Others/'+product+'/Delete')
                        .then(response => [
                            this.getProducts(),
                            console.log(response)
                        ]),
                    )
                }
            })
        }

     }
}
</script>




// WEBPACK FOOTER //
// resources/js/Item/Others.vue